<template>
    <template-layout :breadCrumbList="breadcrumbComputed">
        <OverviewCard :data-overview="overviewStatsDataObj"/>
        <Statistics @updateOverAll="overviewStatsDataObj = $event"/>
    </template-layout>
</template>

<script setup>
import { reactive, ref } from "vue"
import TemplateLayout from "@/layouts/side-menu/Main.vue"
import OverviewCard from "./container/OverviewCard.vue"
import Statistics from "./container/Statistics.vue"
const breadcrumbComputed = reactive([{
  name: "ภาพรวมโครงการ",
  active: true
}])
const overviewStatsDataObj = ref({})
</script>

<style>

</style>